import { Icon, TIconName } from 'shared_DEPRECATED/components/Icon';

import { ParticipantsTableActionWrapper } from 'features/participants/components/Table/Actions/Wrapper';

import { Tooltip } from 'shared/components/Tooltip';
import { Typography } from 'shared/components/Typography';

type ParticipantsTableActionDisabledPropTypes = {
  label: string;
  icon: TIconName;
};

export const ParticipantsTableActionDisabled = ({
  label,
  icon,
}: ParticipantsTableActionDisabledPropTypes) => (
  <Tooltip
    content={
      <Typography type="small" color="white">
        {label}
      </Typography>
    }
    positioning={{ offset: 8, placement: 'bottom-start' }}
  >
    <ParticipantsTableActionWrapper>
      <Icon name={icon} stroke="var(--fgTertiary)" width="18px" height="18px" />
    </ParticipantsTableActionWrapper>
  </Tooltip>
);
